import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const TemplateCardFallback = () => {
  return (
    <Card className="p-2 gap-2 transition-shadow hover:shadow-lg cursor-pointer">
      <CardHeader className="pb-0 px-2 pt-2">
        <div className="flex items-center gap-2">
          <Skeleton className="size-[24px] rounded-full" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </CardHeader>
      <CardDescription className="px-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="mt-3 h-3.5 w-7/8 " />
      </CardDescription>
      <CardContent className="mt-auto px-2 py-2.5">
        <div className="flex items-center gap-1.5 mt-1">
          <Skeleton className="size-4 rounded-xs" />
          <Skeleton className="h-3 w-1/4" />
        </div>
      </CardContent>
      <CardFooter className="px-2 py-2">
        <Skeleton className="h-8 w-1/3" />
      </CardFooter>
    </Card>
  )
}
